
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/show-home-opening-times/[[...town]]",
      function () {
        return require("private-next-pages/show-home-opening-times/[[...town]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/show-home-opening-times/[[...town]]"])
      });
    }
  